// extracted by mini-css-extract-plugin
module.exports = {"login_btn":"index-module__login_btn___Y4l5w","join_btn":"index-module__join_btn___Y2YRj"};